import { ReactNode } from 'react';

interface PanelProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  headerAction?: ReactNode;
}

export function Panel({ title, children, className = '', contentClassName = 'space-y-4', headerAction }: PanelProps) {
  return (
    // p-6 either side costs a phone 48px of an already narrow row, which is
    // what pushes the widest fields (ZIP, date pickers) past the viewport.
    <div className={`bg-white rounded-lg shadow p-4 sm:p-6 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        {typeof title === 'string' ? (
          <h2 className="text-lg font-bold text-gray-900">
            {title}
          </h2>
        ) : (
          title
        )}
        {headerAction}
      </div>
      {contentClassName ? (
        <div className={contentClassName}>
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
}
